/**
 * ProjectRax — Tier / Plan API Service (Client)
 */
import api from './api';

const tierService = {
  /**
   * Get current organization plan with usage stats
   */
  getCurrentPlan: () => api.get('/tier/plan'),

  /**
   * Get all features with accessible/locked status
   */
  getFeatures: () => api.get('/tier/features'),

  /**
   * Check if a specific feature is accessible
   * @param {string} featureId
   */
  checkFeature: (featureId) => api.get(`/tier/check/${featureId}`),

  /**
   * Get detailed usage breakdown
   */
  getUsage: () => api.get('/tier/usage'),

  /**
   * Get all available plans with pricing
   */
  listPlans: () => api.get('/tier/plans'),

  /**
   * Upgrade organization plan
   * @param {string} plan - 'professional' | 'premium' | 'enterprise'
   */
  upgradePlan: (plan) => api.put('/tier/upgrade', { plan }),
};

export default tierService;
